import { render, staticRenderFns } from "./FieldActivities.vue?vue&type=template&id=632dd0c1&scoped=true&"
import script from "./FieldActivities.vue?vue&type=script&lang=js&"
export * from "./FieldActivities.vue?vue&type=script&lang=js&"
import style0 from "./FieldActivities.vue?vue&type=style&index=0&id=632dd0c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632dd0c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCol,VIcon,VProgressCircular,VSimpleTable,VTab,VTabItem,VTabs,VTabsItems})
